// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_c6-0";